import { defineMessages } from 'react-intl';

const messages = defineMessages({
  main_heading: {
    id: 'XAj6gD',
    defaultMessage: 'IBM Cloud Object Storage Price Estimator',
  },
  sub_heading: {
    id: 'rr3pjj',
    defaultMessage:
      'Estimate your IBM Cloud Object Storage price by choosing from a Backup/Recovery example below, or entering your own capacity.',
  },
  inline_heading: {
    id: 'yUA/zG',
    defaultMessage: 'Optimize backup and recovery',
  },
  inline_sub_heading: {
    id: 'u/YF6u',
    defaultMessage:
      'Use the price estimator below to estimate the costs of storing backups on COS:',
  },
  inline_sub_option_1: {
    id: 'xRpSNK',
    defaultMessage:
      'Simply input the backend storage capacity you expect to use for backups after any deduplication by your backup application.',
  },
  inline_sub_option_2: {
    id: '6rbq9+',
    defaultMessage:
      'This estimator uses a storage class called “Vault,” which is ideal for backup workloads with infrequent data retrieval',
  },
  inline_sub_option_3: {
    id: 'vDLR+U',
    defaultMessage:
      'Leverage Cloud Object Storage Cyber Vault with immutable data protection for Cyber Resiliency, Ransomware and Air Gap from Production.',
  },
  pricing_estimated: {
    id: 'fmQHuS',
    defaultMessage: 'Estimated monthly price for this configuration',
  },
  pricing_configuration: {
    id: 's0KuHp',
    defaultMessage: 'Configuration includes:',
  },
  pricing_backup_storage: {
    id: 'IvtOOO',
    defaultMessage: 'Backup Storage',
  },
  pricing_backup_storage_tooltip: {
    id: '+zWAaE',
    defaultMessage:
      'Total amount of data stored in backup across your buckets.',
  },
  pricing_storage_bucket: {
    id: '+XJ6A4',
    defaultMessage: 'Storage Bucket',
  },
  pricing_storage_bucket_tooltip: {
    id: 'w3/l+O',
    defaultMessage:
      'Storage tier where your objects and associated data are stored.',
  },
  pricing_backup_restore: {
    id: 'uqcty0',
    defaultMessage: 'Backup Restore',
  },
  pricing_backup_restore_tooltip: {
    id: 'KQx9Xv',
    defaultMessage: 'Volume of data retrieved from backup buckets.',
  },
  pricing_write_requests: {
    id: 'GDDLFM',
    defaultMessage: 'Write requests (class A)',
  },
  pricing_write_requests_tooltip: {
    id: 'oiBb+G',
    defaultMessage: 'Number of write operations on objects in your bucket.',
  },
  pricing_read_requests: {
    id: 'yCMWxy',
    defaultMessage: 'Read requests (class B)',
  },
  pricing_read_requests_tooltip: {
    id: 'J4lMqU',
    defaultMessage:
      'Number of read operations performed on objects in your bucket.',
  },
  pricing_disclaimer: {
    id: 'p3PQ2L',
    defaultMessage: 'Estimated prices do not include tax',
  },
  pricing_buy_now: {
    id: 'u5AfPm',
    defaultMessage: 'Buy now',
  },
  request_a_quote: {
    id: 'r4tIGb',
    defaultMessage: 'Request a quote',
  },
  returnToEstimator: {
    id: '8fgwsI',
    defaultMessage: 'Return to price estimator',
  },
  thank_you: {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  received_text: {
    id: 'PwjLGb',
    defaultMessage: 'We have received your request',
  },
  req_detail: {
    id: '0L49M8',
    defaultMessage: 'Request details:',
  },
  bp_title: {
    id: 'BkHBGW',
    defaultMessage: 'Selected Business Partner',
  },
  small_10_tb: {
    id: 'Tbrede',
    defaultMessage: 'Small 10 TB',
  },
  s2_27_tb: {
    id: 'oXrCfS',
    defaultMessage: '27 TB',
  },
  medium_100_tb: {
    id: 'map4GV',
    defaultMessage: 'Medium 100 TB',
  },
  medium_71_tb: {
    id: 'kuTikZ',
    defaultMessage: 'Medium 71 TB',
  },
  m2_188_tb: {
    id: 'XQ0dH3',
    defaultMessage: '188 TB',
  },
  large_500_tb: {
    id: 'weOcVg',
    defaultMessage: 'Large 500 TB',
  },
  custom_backup_storage: {
    id: 'evrX0E',
    defaultMessage: 'Custom backup storage (TB)',
  },
  custom_backup_storage_error_message: {
    id: '768knM',
    defaultMessage: 'Please enter number between 10 TB - 500 TB.',
  },
  legal_disclaimer_1: {
    id: 'ej32d/',
    defaultMessage:
      'Calculated prices are estimates provided for planning purposes only taking into account potential IBM discounts and are not a formal offer from IBM or an IBM Business Partner. The estimation may reflect the total discounted price. Certain factors such as configuration, add-ons, additional requirements or related services will affect final price. IBM Business Partners set and provide their own IBM Cloud Object Storage ',
  },
  legal_disclaimer_2: {
    id: 'Jqc/oe',
    defaultMessage:
      ' and neither IBM nor IBM Business Partners are bound by the provided estimate.',
  },
});

export default messages;
